<template>
    <v-card
      ref="listRoot"
      class="ma-0 px-1 app-list-page"
      :class="{
        'app-list-page--fixed': !isMobile && !mobileShow,
      }"
      width="100%"
      style="height: auto"
      flat
    >
      <v-app-bar
        ref="listToolbar"
        flat
        class="my-0 app-list-toolbar"
        :class="!isMobile && !mobileShow ? 'px-2 mb-0 py-0' : 'mb-6 py-1 px-2'"
        dense
        :height="!isMobile && !mobileShow ? 40 : 30"
      >
        <v-toolbar-title
          class="app-list-toolbar__title"
          :class="!isMobile && !mobileShow ? 'me-4' : 'mt-4 me-4'"
        >{{ $t('subGroup') }}</v-toolbar-title>
        <div
          v-if="!isMobile && !mobileShow"
          class="app-list-toolbar__search"
          style="width: 230px;"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            clearable
            :label="$t('search')"
            flat
            outlined
            dense
            hide-details
          />
        </div>
        <v-spacer />
        <v-btn
          v-if="selected.length > 0 && !isMobile && !mobileShow"
          outlined
          @click="deletDialog = true"
          class="mt-4 ms-2"
          color="pink"
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('remove') }}
          </p>
          <v-icon>
            mdi-trash-can-outline
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="getItems"
          class="mt-4 px-1 ms-2"
          color="grey darken-2"
          height="32"
          @shortkey="getItems"
          v-shortkey="['f5']"
          style="min-width: 35px !important;padding: 0 !important;"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!isMobile && !mobileShow"
          outlined
          class="mt-4 ms-2"
          color="primary"
          height="32"
          @click="openDialog('add')"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t('new-sub-group') }}
          </p>
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-app-bar>
      <v-row
        v-if="isMobile || isTablet"
        class="mx-0"
      >
        <v-col
          class="mb-4 px-2"
          cols="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            clearable
            :label="$t('search')"
            flat
            outlined
            dense
          />
        </v-col>
      </v-row>
      <v-col
        ref="listTableCol"
        cols="12"
        class="px-2 app-list-table-col"
        :class="{ 'mt-2': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
      >
        <v-data-table
          v-if="headers"
          ref="listTable"
          v-model="selected"
          v-column-resize="subGroupColumnPlugins"
          v-column-drag="subGroupColumnPlugins"
          v-column-pin="subGroupColumnPlugins"
          :height="(isMobile || mobileShow ? 323 : tableHeight)"
          fixed-header
          :headers="showHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="page"
          :hide-default-header="isMobile || mobileShow"
          multi-sort
          :show-select="showSelect"
          item-key="id"
          class="mb-2 td-hide-border app-list-table main-table invoice-sell-table-scroll"
          :class="{
            'mb-0 app-list-table--dense': !isMobile && !mobileShow,
          }"
          :style="
            !isMobile && !mobileShow
              ? 'border: 1px solid #e3e3e3; border-radius: 2px'
              : 'border: 1px solid #e3e3e3; border-radius: 6px'
          "
          :footer-props="{
            showFirstLastPage: (!mobileShow ? true : false),
            itemsPerPageOptions: [10, 25, 50, 100, 500],
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-plus',
            nextIcon: 'mdi-minus'
          }"
        >
          <template
            v-if="isMobile || mobileShow"
            v-slot:item="{ item, index }"
          >
            <tr :class="{'mobile-show': mobileShow}">
              <td class="px-0">
                <v-list-item
                  class="data-table-list-items mobile-td-list-border-primary"
                  dense
                >
                  <v-list-item-icon>
                    <div class="d-flex">
                      <p class="mt-1">
                        {{ +index + +1 }}
                      </p>
                      <v-menu
                        offset-y
                      >
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            color="primary"
                            v-bind="attrs"
                            icon
                            v-on="on"
                          >
                            <v-icon
                              medium
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item
                            link
                            @click="openDialog('edit', item, index)"
                          >
                            <v-list-item-icon>
                              <v-icon class="mt-2">
                                mdi-clipboard-edit
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title v-text="$t('edit')" />
                          </v-list-item>
                          <v-list-item
                            v-show="removePermission(typeForm)"
                            link
                            @click="openDeleteDialog(item)"
                          >
                            <v-list-item-icon>
                              <v-icon color="pink">
                                mdi-trash-can-outline
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title v-text="$t('remove')" />
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">
                      {{ item.name }}({{ item.code }})
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </td>
            </tr>
          </template>
          <template v-slot:item.actions="{ item, index }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  @click="openDialog('edit', item, index)"
                >
                  <v-list-item-icon>
                    <v-icon class="mt-2">
                      mdi-clipboard-edit
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('edit')" />
                </v-list-item>
                <v-list-item
                  v-show="removePermission(typeForm)"
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.row="{ item }">
            <v-card-text
              class="pa-0 text-caption text-disable"
            >
              {{ parseInt(items.indexOf(item)) + parseInt(from) }}
            </v-card-text>
          </template>
          <template v-slot:item.category="{ item, index }">
            <v-card-text 
              class="pa-0"
              :class="{ 'text-body-2': item.name, 'text-caption': item.name == null }"
              style="color: #0066ff;cursor: pointer;"
              @click="openDialog('edit', item, index)"
            >
              {{ 
                (item.name && item.name != null) ? item.name : 
                (item.category && item.category != null) ? item.category : 
                $t('haveNot')
              }}
            </v-card-text>
          </template>
          <template v-slot:item.group="{ item, index }">
            <v-card-text 
                class="pa-0"
                :class="{ 
                'text-body-2': resolveGroupName(item.parent_id) != $t('haveNot') || !item.parent_id, 
                'text-caption': resolveGroupName(item.parent_id) == $t('haveNot')
                }"
                :style="{
                'color': resolveGroupName(item.parent_id) != $t('haveNot') || !item.parent_id ? '#0066ff' : '#919090', 
                'cursor': resolveGroupName(item.parent_id) != $t('haveNot') || !item.parent_id ? 'pointer' : 'auto'
                }"
                @click="openDialog('edit', item, index)"
            >
              {{
                item.parent_id ? 
                resolveGroupName(item.parent_id) :
                item.group?.name
              }}
            </v-card-text>
          </template>
          <template v-slot:item.subCategory="{ item, index }">
            <v-card-text class="pa-0 text-body-2">
                {{
                item.id != undefined ?
                resolveSubCategoryCount(item.id) :
                '-'
                }}
            </v-card-text>
          </template>
          <template v-slot:item.productCount="{ item }">
            <v-card-text 
              class="pa-0"
              :class="{ 'text-body-2': item.id, 'text-caption': item.id == null }"
            >
              {{ item.products_count != undefined ? item.products_count : $t('haveNot') }}
            </v-card-text>
          </template>
          <template v-slot:footer.prepend>
            <v-col
              v-show="!isMobile"
              cols="1"
              class="pa-0 app-list-goto-page"
              :class="{
                'app-list-goto-page--compact': !isMobile && !mobileShow,
              }"
              :style="
                !isMobile && !mobileShow ? null : 'margin-top: -10px'
              "
            >
              <!-- Flat glass: no border/shadow — bg via inline so footer CSS cannot override -->
              <div
                class="app-list-goto-page__box"
                :style="
                  !isMobile && !mobileShow
                    ? {
                        height: '24px',
                        padding: '0 8px',
                        borderRadius: '4px',
                        backgroundColor: 'rgba(120, 130, 140, 0.12)',
                        border: 'none',
                        boxShadow: 'none',
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                      }
                    : null
                "
              >
                <span
                  v-if="!isMobile && !mobileShow"
                  class="app-list-goto-page__label"
                  >{{ $t('goToPage') }}</span
                >
                <v-text-field
                  v-model.number="page"
                  :label="
                    !isMobile && !mobileShow ? undefined : $t('goToPage')
                  "
                  min="1"
                  :max="pageCount"
                  type="number"
                  :outlined="isMobile || isTablet || mobileShow"
                  :solo="!isMobile && !mobileShow"
                  :flat="!isMobile && !mobileShow"
                  :height="!isMobile && !mobileShow ? 20 : 32"
                  hide-details
                  hide-spin-buttons
                  dense
                  :suffix="' / ' + pageCount"
                  class="app-list-goto-page__field"
                />
              </div>
            </v-col>
          </template>
        </v-data-table>
      </v-col>
      <v-row />
  
      <!--delete dialog items of list-->
      <v-dialog
        v-model="deletDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="400"
      >
        <v-card>
          <v-col>
            <v-btn
              icon
              class="close-hover"
              @click="deletDialog = false"
            >
              <v-icon
                color="grey"
                large
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-img
              class="mx-auto"
              width="200"
              src="@/assets/stop.svg"
            />
          </v-col>
          <v-col
            class="mt-3 pr-7"
          >
            <p class="mx-auto font-weight-medium">
              {{ $t('are-you-sure-delete-this-case') }}
            </p>
          </v-col>
          <v-card-actions>
            <v-row class="ma-0">
              <v-col cols="6">
                <v-btn
                  v-if="selected.length > 0"
                  color="primary"
                  :loading="loading"
                  @click="removegroup"
                >
                  {{ $t('remove') }}
                </v-btn>
                <v-btn
                  v-if="selected.length == 0"
                  color="primary"
                  @click="removegroup"
                >
                  {{ $t('remove') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  color="grey"
                  outlined
                  class="float-left"
                  @click="deletDialog = false"
                >
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--dialog list (add + edit)-->
      <v-dialog
        v-model="gpDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="400"
      >
        <v-card class="pa-5" height="263">
          <v-form ref="form" v-model="valid">
            <v-container class="pa-0 d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-1">
                {{ dialogType == 'add' ?  $t('new-sub-group') : $t('edit-sub-group') }}
              </v-card-text>
              <v-icon @click="gpDialog = false" style="cursor: pointer;">mdi-close</v-icon>
            </v-container>
            <aicomplete
              v-model="group"
              :val="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({parent:0,type:'group'})"
              class="mt-8"
              :rules="[v => !!v || $t('is-required')]"
            />
            <v-card-text class="pa-0 text-body-2 mt-8">{{ $t('enter your category name') }}</v-card-text>
            <v-text-field
              v-model="category"
              :label="$t('category-title')"
              height="32"
              dense
              outlined
              clearable
              class="mt-3"
              :rules="[v => !!v || $t('is-required')]"
            />
            <v-container class="d-flex align-center gap-2 pa-0 mt-9">
              <v-btn
                color="primary"
                :loading="loading"
                height="32"
                @click="checkValidation"
                :disabled="!itemHasId"
              >
              {{ dialogType == 'add' ? $t('confirm') : $t('edit') }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                :loading="loading"
                height="32"
                @click="gpDialog = false"
              >
              {{ $t('cancel') }}
              </v-btn>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snakbar"
        :color="(snakbarColor ? snakbarColor : 'primary')"
        top
        style="z-index: 1000000000000 !important;"
      >
        {{ snakbarText }}
  
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snakbar = !snakbar"
          >
            {{ $t('close') }}
          </v-btn>
        </template>
      </v-snackbar>
      <Confirm ref="confirm" />
    </v-card>
  </template>
  
  <script>
    import General from '../../../../Mixins/general'
    import {
      applyColumnSettings,
      loadColumnSettings,
    } from '@/plugins/columnSettings/columnSettings'
    import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
    export default {
      name: 'category',
      components: {
        autocomplete: () => import('../../components/general/patial/autocomplete'),
        aicomplete: () => import('../../components/general/AIcomplete/index')
      },
      mixins: [General],
      props: ['input', 'type', 'refId', 'mobileShow', 'titleProp'],
      data: () => ({
        selected: [],
        pageCount: 1,
        page: 1,
        selectedHeaders: [],
        deletDialog: false,
        showSelect: true,
        model: null,
        from: 1,
        temp: null,
        deleteItem: null,
        items: [],
        subCategoryList: [],
        groupList: [],
        sortBy: [],
        dialog: null,
        timer: 0,
        totalItems: 0,
        snakbar: false,
        typeForm: null,
        snakbarText: null,
        loading: true,
        options: {
          itemsPerPage: 5,
        },
        headers: null,
        listViewportObserver: null,
        listViewportRaf: null,
        search: null,
        gpDialog: false,
        dialogType: null,
        valid: true,
        editedIndex: null,
        editedItem: null,
        newItem: {},
        group: null,
        category: null,
        itemHasId: true
      }),
      computed: {
        isMobile () {
          return this.$vuetify.breakpoint.name === 'xs'
        },
        isDesktopListViewport () {
          return !this.isMobile && !this.mobileShow
        },
        subGroupColumnPersistKey () {
          return 'group-sub-list-columns-' + (this.$route.name || 'subGroup')
        },
        subGroupLockedColumns () {
          // Fixed sticky block: select + actions + row (no id column in this list)
          var locked = ['actions', 'row']
          return this.showSelect ? ['__select'].concat(locked) : locked
        },
        subGroupColumnPlugins () {
          // show-select inserts a leading checkbox <th>; pad visibleHeaders so
          // pin/resize/drag index mapping stays aligned with thead cells.
          var selectHeader = {
            value: '__select',
            text: '',
            width: 32,
            sortable: false,
            pinned: false,
            originalIndex: -1,
          }
          var visible = this.showSelect
            ? [selectHeader].concat(this.showHeaders || [])
            : this.showHeaders || []
          return {
            headers: this.headers,
            visibleHeaders: visible,
            locked: this.subGroupLockedColumns,
            anchor: 'category',
            minWidth: 60,
            persistKey: this.subGroupColumnPersistKey,
          }
        },
        showHeaders () {
          var app = this
          return this.headers.filter(function (s) {
            return app.selectedHeaders.includes(s)
          })
        },
      },
      watch: {
        refId (val, oldVal) {
          // this.items = []
          this.getItems()
        },
        model () {
          this.$emit('input', this.model)
        },
        selected () {
          this.$emit('input', this.selected.text)
          if (this.selected.length > 0) {
            this.model = this.selected[0].text
            this.temp = this.selected[0].text
          }
          this.dialog = false
        },
        search () {
          var app = this
          app.loading = true
          app.page = 1
          clearTimeout(this.timer)
          this.timer = setTimeout(function () {
            app.getItems()
          }, 1000)
        },
        options: {
          handler () {
            var app = this
            app.sortBy = []
            app.options.sortBy.map(function (value, key) {
              const index = app.headers.findIndex(h => h.value === value)
              app.sortBy.push(app.headers[index].table)
            })
            this.getItems()
          },
          deep: true,
          immediate: false,
        },
        sortBy () {
          const index = this.headers.findIndex(h => h.value === this.sortBy)
          if (index > -1) {
            this.sortBy = this.headers[index].table
          }
        },
        loading (val) {
          if (!val && this.isDesktopListViewport) {
            this.$nextTick(() => {
              this.bindListViewportObserver()
              this.scheduleDesktopTableHeightUpdate()
            })
          }
        },
        isDesktopListViewport (val) {
          if (val) {
            this.$nextTick(() => {
              this.updateDesktopTableHeight()
              this.bindListViewportObserver()
            })
          } else {
            this.unbindListViewportObserver()
            this.tableHeight = window.innerHeight - 245
          }
        },
        group (Val, oldVal) {
          if (Val) {
            if (this.$refs.refCategory) {
              this.$refs.refCategory.clear()
              this.$refs.refCategory.initList = false
              this.$refs.refCategory.getItems()
            }
          }
        }
      },
      beforeMount () {
        if (this.$route.name === 'subGroup') {
          this.typeForm = 'category'
        }
        this.headers = [
          {
            text: this.$t('operation'),
            align: 'start',
            sortable: false,
            value: 'actions',
            width: 20,
          },
          {
            text: this.$t('#'),
            align: 'start',
            sortable: false,
            value: 'row',
            width: 20,
          },
          {
            text: this.$t('sub-group-title'),
            sortable: false,
            value: 'category',
          },
          {
            text: this.$t('main-group'),
            sortable: false,
            value: 'group',
          },
          {
            text: this.$t('sub-category-count'),
            sortable: true,
            value: 'subCategory'
          },
          {
            text: this.$t('countProductInvoice'),
            sortable: false,
            value: 'productCount',
          },
        ]
        if (this.input) {
          this.model = this.input
        }
        this.headersMap = this.headers
        this.selectedHeaders = this.headers
        reorderPinnedHeaders(this.headers, {
          locked: this.subGroupLockedColumns,
          anchor: 'category',
        })
        this.loadSubGroupColumnSettings()
      },
      methods: {
        resolveRefEl (ref) {
          if (!ref) return null
          return ref.$el || ref
        },
        onResize () {
          if (this.isDesktopListViewport) {
            this.updateDesktopTableHeight()
            return
          }
          this.tableHeight = window.innerHeight - 245
        },
        scheduleDesktopTableHeightUpdate () {
          if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
          this.listViewportRaf = requestAnimationFrame(() => {
            this.listViewportRaf = null
            this.updateDesktopTableHeight()
          })
        },
        updateDesktopTableHeight () {
          if (!this.isDesktopListViewport) {
            this.tableHeight = window.innerHeight - 245
            return
          }
          const rootEl = this.resolveRefEl(this.$refs.listRoot)
          const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
          const summaryEl = this.resolveRefEl(this.$refs.listSummary)
          const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
          const tableEl = this.resolveRefEl(this.$refs.listTable)
          if (!rootEl || !tableColEl) {
            this.tableHeight = window.innerHeight - 245
            return
          }
          const rootStyle = window.getComputedStyle(rootEl)
          const rootPadding =
            (parseFloat(rootStyle.paddingTop) || 0) +
            (parseFloat(rootStyle.paddingBottom) || 0)
          const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
          let summaryHeight = 0
          if (summaryEl) {
            const summaryVisible =
              summaryEl.offsetParent !== null ||
              summaryEl.getClientRects().length > 0
            if (summaryVisible) {
              const summaryStyle = window.getComputedStyle(summaryEl)
              summaryHeight =
                summaryEl.offsetHeight +
                (parseFloat(summaryStyle.marginTop) || 0) +
                (parseFloat(summaryStyle.marginBottom) || 0)
            }
          }
          const colStyle = window.getComputedStyle(tableColEl)
          const colPadding =
            (parseFloat(colStyle.paddingTop) || 0) +
            (parseFloat(colStyle.paddingBottom) || 0)
          const footerEl = tableEl
            ? tableEl.querySelector('.v-data-footer')
            : null
          const footerHeight = footerEl ? footerEl.offsetHeight : 0
          const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
          const tableMargins = tableStyle
            ? (parseFloat(tableStyle.marginTop) || 0) +
              (parseFloat(tableStyle.marginBottom) || 0)
            : 0
          const available =
            rootEl.clientHeight -
            rootPadding -
            toolbarHeight -
            summaryHeight -
            colPadding -
            footerHeight -
            tableMargins -
            3
          this.tableHeight = Math.max(180, Math.floor(available))
        },
        bindListViewportObserver () {
          if (typeof ResizeObserver === 'undefined') return
          this.unbindListViewportObserver()
          const rootEl = this.resolveRefEl(this.$refs.listRoot)
          const summaryEl = this.resolveRefEl(this.$refs.listSummary)
          const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
          const tableEl = this.resolveRefEl(this.$refs.listTable)
          const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
          if (!rootEl && !summaryEl && !tableColEl) return
          this.listViewportObserver = new ResizeObserver(() => {
            this.scheduleDesktopTableHeightUpdate()
          })
          if (rootEl) this.listViewportObserver.observe(rootEl)
          if (summaryEl) this.listViewportObserver.observe(summaryEl)
          if (tableColEl) this.listViewportObserver.observe(tableColEl)
          if (footerEl) this.listViewportObserver.observe(footerEl)
        },
        unbindListViewportObserver () {
          if (this.listViewportObserver) {
            this.listViewportObserver.disconnect()
            this.listViewportObserver = null
          }
        },
        loadSubGroupColumnSettings () {
          var app = this
          if (!app.headers || !app.headers.length) return
          loadColumnSettings(app, app.subGroupColumnPersistKey).then(function (snapshot) {
            if (!snapshot || !snapshot.length) return
            applyColumnSettings(app.headers, snapshot, {
              locked: app.subGroupLockedColumns,
              anchor: 'category',
            })
            app.$forceUpdate()
          })
        },
        getItems () {
          var app = this
          app.loading = true
          app.$axios.get(this.$endpoint + 'productcategory', {
            params: {
                type: 'category',
                page: app.options.page,
                itemPerPage: 10,
                parents: null,
                filter: null,
                search: this.search
            },
          })
            .then(res => {
                res = res.data
                app.items = res.data
                app.totalItems = res.total
                app.pageCount = res.last_page
                app.from = res.from
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.loading = false))
        },
        getGroupList () {
            var app = this
            app.loading = true
            app.$axios.get(this.$endpoint + 'productcategory', {
                params: {
                    type: 'group',
                    page: 1,
                    itemPerPage: 10000,
                    parents: null,
                    filter: null,
                    search: null
                },
            })
            .then(res => {
                res = res.data
                app.groupList = res.data
            })
        },
        getSubCategoryList () {
            var app = this
            app.loading = true
            app.$axios.get(this.$endpoint + 'productcategory', {
                params: {
                    type: 'subCategory',
                    page: 1,
                    itemPerPage: 10000,
                    parents: null,
                    filter: null,
                    search: null
                },
            })
            .then(res => {
                res = res.data
                app.subCategoryList = res.data
            })
        },
        resolveGroupName (value, type) {
            if (this.groupList.length > 0 && value != null) {
                const group = this.groupList.find(obj => obj.id == value)
                if (group && group.name != null) {
                    return (type && type == 'edit') ? group : group.name
                }
            }
            return this.$t('haveNot')
        },
        resolveSubCategoryCount (categoryId) {
            if (this.subCategoryList.length > 0) {
                const subCategory = this.subCategoryList.filter(item => item.parent_id == categoryId)
                return subCategory.length
            }
        },
        openDialog (type, item, index) {
          this.dialogType = type
          this.gpDialog = true
          if (this.dialogType == 'add') {
            this.itemHasId = true
            this.clearModal()
          }
          if (this.dialogType == 'edit' && item != undefined && index != undefined) {
            if (item.id != undefined) {
              this.category = this.items[index].name
              this.group = this.resolveGroupName(this.items[index].parent_id, 'edit')
              this.itemHasId = true
            } else {
              this.category = this.items[index].category
              this.group = this.items[index].group
              this.itemHasId = false
            }
            this.editedIndex = index
            this.editedItem = item
          }
        },
        clearModal () {
          this.category = null
          this.group = null

          if (this.$refs.form) {
            this.$refs.form.reset()
          }
        },
        checkValidation () {
          if (this.dialogType == 'add' && this.$refs.form.validate()) {
            this.add()
          }
          if (this.dialogType == 'edit' && this.$refs.form.validate()) {
            this.edit()
          }
        },
        add () {
          this.newItem.category = this.category
          this.newItem.group = this.group

          var app = this
          app.loading = true
          app.$axios.post(this.$endpoint + 'productcategory', {
            name: this.newItem.category,
            type: "category",
            parent: this.newItem.group.id
          })
            .then(res => {
              this.items.push({ ...this.newItem })
              this.gpDialog = false
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.loading = false))
        },
        edit () {
          this.newItem.category = this.category
          this.newItem.group = this.group

          var app = this
          app.loading = true
          var id = this.editedItem.id
          app.$axios.put(`${this.$endpoint}productcategory/${id}`, {
            name: this.newItem.category,
            type: "category",
            parent: this.newItem.group.id
          })
            .then(res => {
              this.items.splice(this.editedIndex, 1, JSON.parse(JSON.stringify(this.newItem)))
              this.gpDialog = false
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.loading = false))
        },
        openDeleteDialog (item) {
          this.deleteItem = item
          this.deletDialog = true
        },
        removegroup () {
          var app = this
          app.loading = true

          if (this.selected.length  > 0) {
            var selected = []
            this.selected.map(function (value) {
              selected.push(value.id)
            })
            
            const ids = selected.join(',')

            app.$axios.delete(`${this.$endpoint}productcategory/${ids}`)
              .then(res => {
                this.getItems()
                app.deletDialog = false
                app.deleteItem = null
                app.selected = []
              })
              .catch(err => {
                this.deletDialog = false
                this.serverErrorHandeler(err)
              })
              .finally(function () {
                app.deleteItem = null
                app.selected = []
                app.loading = false
              })
          } else {
            app.$axios.delete(this.$endpoint + 'productcategory/' + this.deleteItem.id)
              .then(res => {
                this.getItems()
                app.deletDialog = false
                app.deleteItem = null
                app.selected = []
              })
              .catch(err => {
                this.deletDialog = false
                this.serverErrorHandeler(err)
              })
              .finally(function () {
                app.deleteItem = null
                app.selected = []
                app.loading = false
              })
          }
        },
        
      },
      mounted () {
        this.getGroupList()
        this.getSubCategoryList()
        if (this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.updateDesktopTableHeight()
            this.$nextTick(() => {
              this.bindListViewportObserver()
              this.scheduleDesktopTableHeightUpdate()
            })
          })
        }
      },
      activated () {
        if (this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      deactivated () {
        this.unbindListViewportObserver()
      },
      beforeDestroy () {
        this.unbindListViewportObserver()
        if (this.listViewportRaf) {
          cancelAnimationFrame(this.listViewportRaf)
          this.listViewportRaf = null
        }
      }
    }
  </script>
  
  <style scoped>
  ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 32px !important;
  }
  ::v-deep .v-input--selection-controls__input {
    margin-left: 0;
    width: auto;
  }
  ::v-deep .v-input--selection-controls__ripple {
    width: auto;
    height: auto;
    margin: 0;
  }
  ::v-deep .v-btn--icon.v-size--default {
    height: auto;
    width: auto;
  }
  ::v-deep .v-data-table table thead tr th,
  ::v-deep .v-data-table table tbody tr td {
    white-space: nowrap;
  }
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
  ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    /* background-color: transparent !important; */
    height: 60px;
  }
  .v-card__text {
    width: auto;
  }
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background-color: silver;
  }
  
  .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
  @media (max-width: 863px) {
    ::v-deep .v-data-table table tbody tr,
    ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
    ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
      height: auto;
    }
  }
  </style>
  